import { useDispatch, useSelector } from 'react-redux';
import EpfoCard from './EpfoCard';
import GstCard from './GstCard';
import { useParams } from 'react-router-dom';
import { RootState } from '@cp/src/store';
import { createKey } from '@cp/src/utils/CaseDetail.utils';
import { useEffect, useState } from 'react';
import { fetchSherlockData } from '../../actions/SkipTracingAction';
import { addClickstreamEvent } from '@cp/src/service/clickStreamEventService';
import { CLICKSTREAM_EVENT_NAMES } from '@cp/src/service/clickStream.constant';
import { ISherlock } from '../../interfaces/CaseDetail.type';
import styles from './index.module.scss';
import EmptyFileIcon from '@cp/src/assets/icons/EmptyFileIcon';
import Loader from '@cp/src/components/Loader/Loader';

const SkipTracing = () => {
  const dispatch = useDispatch();
  const { loanId = '', customerId = '' } = useParams();
  const [loading, setLoading] = useState(false);
  const sherlockData = useSelector(
    (state: RootState) => state.caseDetail.pageData?.[createKey(loanId, customerId)]?.sherlock?.data
  );

  useEffect(() => {
    if (!sherlockData) {
      dispatch(fetchSherlockData(loanId, customerId, setLoading));
    }
    addClickstreamEvent(CLICKSTREAM_EVENT_NAMES.LH_SKIPTRACING_PAGELAND);
  }, [loanId, customerId]);

  return (
    <div className={styles.tableContentScroll}>
      {sherlockData?.length ? (
        sherlockData?.map((cardData: ISherlock, index: number) => {
          return (
            <div key={index} className={styles.cardWrapper}>
              {(cardData.type === 'EPFO' || cardData.type === 'UAN') && (
                <EpfoCard data={cardData} />
              )}
              {cardData.type === 'GST' && <GstCard data={cardData} />}
            </div>
          );
        })
      ) : (
        <div className={styles.noData}>
          <div>
            <EmptyFileIcon />
          </div>
          No Customer Outreach data available at this moment.
        </div>
      )}
    </div>
  );
};

export default SkipTracing;
